import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateModules } from "../../actions";
import {
  OsnTextarea,
  Button,
  OsnInputText,
} from "@identitybuilding/idb-react-ui-elements";
import News from "@identitybuilding/idb-react-news-articles/dist/components/NewsArticles";
import axios from "axios";

const NewsEdit = (props) => {
  const dispatch = useDispatch();

  let modules = useSelector((state) => state.AdminReducer.modules);
  let data = useSelector((state) => state.AdminReducer.data);

  let [newsTitle, setNewsTitle] = useState(data.options.news.title);
  let entityCopy = Object.assign({}, data);
  let modulcesCopy = [...modules];

  const handler = (action, keyword) => {
    if (action === "template") {
      entityCopy.options.news.template = keyword;
      adminChange(keyword, action);
    }
    if (action === "theme") {
      entityCopy.options.news.theme = keyword;
      adminChange(keyword, action);
    }
    if (action === "title") {
      entityCopy.options.news.title = keyword;
      adminChange(keyword, action);
    }

    modulcesCopy[props.index].module = (
      <News
        template={entityCopy.options.news.template}
        theme={entityCopy.options.news.theme}
        news_articles={entityCopy.options.news.articles}
        title={entityCopy.options.news.title}
      />
    );
    dispatch(updateModules(modulcesCopy));
    // setModules(modulcesCopy);
  };
  const adminChange = (props, action) => {
    axios
      .put(
        `https://onepage-78a00-default-rtdb.europe-west1.firebasedatabase.app/data/data/options/news.json`,
        {
          [action]: props,
          ...entityCopy.options.news,
        }
      )
      .then(async (resp) => {
      });
  };

  return (
    <div className="testBlock">
      <div className="testTitle">News</div>
      <div>
        <span>Title:</span>
        <OsnInputText
          onChange={(e) => setNewsTitle(e.target.value)}
          value={newsTitle}
          placeholder={newsTitle}
        />
        <Button
          bgColor={["cn"]}
          size="S"
          text="Change title"
          txtColor="white"
          type="main"
          onClick={() => handler("title", newsTitle)}
        />
      </div>
      <div>
        <span>Template:</span>
        <ul>
          <li onClick={() => handler("template", 1)}>1</li>
          <li onClick={() => handler("template", 2)}>2</li>
          <li onClick={() => handler("template", 3)}>3</li>
          <li onClick={() => handler("template", 4)}>4</li>
        </ul>
      </div>
      <div>
        <span>Theme:</span>
        <ul>
          <li onClick={() => handler("theme", "dark")}>dark</li>
          <li onClick={() => handler("theme", "light")}>light</li>
        </ul>
      </div>
    </div>
  );
};

export default NewsEdit;
